import _ from 'lodash';

const cp = s => s === 'CommercialProperty';
const ho = s => s === 'Homeowners';

export default class TWIACommonUtil {

    /**
     * Filters the availableValues, so it contains only the allowedCodes
     * @param aspects
     * @param availableValues
     * @param [string] allowedCodes
     * @returns {Array|undefined}
     */

    static filterCodesFromAvailableAspects({aspects = undefined, aspects: {availableValues} = undefined }, allowedCodes = []) {
        if (!aspects || !availableValues) {
            return undefined;
        }

        allowedCodes = _.filter(availableValues, (i) => {
            return allowedCodes.indexOf(i.code) !== -1;
        });
        
        return allowedCodes;
    }

    /**
     * DE12046 - Determine which primary-phone-type is default
     */
    static getDefaultAccountHolderPrimaryPhoneType(contactType, primaryPhoneType, productCode) {
        let defaultPrimaryPhoneType;
        // Determine the appropriate default
        if (TWIACommonUtil.isHomeOwners(productCode)) {
            defaultPrimaryPhoneType = (contactType === 'person') ? 'home' : 'work';
        } else if (TWIACommonUtil.isCommercialProperty(productCode)) {
            defaultPrimaryPhoneType = 'work';
        } else {
            throw new Error(`Invalid Product Code :${productCode}`);
        }
        const [first = {}] = TWIACommonUtil.filterCodesFromAvailableAspects(primaryPhoneType, [defaultPrimaryPhoneType]);
        return first;
    }

    static isCommercialProperty(productCode) {
        return cp(productCode);
    }

    static isHomeOwners(productCode) {
        return ho(productCode);
    }

}
